import React from "react";
import { ItemFilter, FiltersProps } from "../helpers/interfaceHelper";
import ItemFilters from "./ItemFilters";

const assetFilters: ItemFilter[] = [
    {
        property: "client_name",
        name: "Companies",
        endpoint: "AssetClients"
    },
    {
        property: "location",
        name: "Location",
        endpoint: "AssetLocations"
    },
    {
        property: "product",
        name: "Product",
        endpoint: "AssetProducts"
    },
    {
        property: "type",
        name: "Asset Type",
        endpoint: "AssetTypes"
    },
    {
        property: "vendor",
        name: "Vendor",
        endpoint: "AssetVendors"
    }
];

const AssetsFilters: React.FC<FiltersProps> = ({
    setFilter,
    resetFilter,
    dbViews,
    view,
    setView,
    setDefaultView,
    search,
    setSearch,
    query
}) => (
        <ItemFilters 
            setFilter = {setFilter}
            resetFilter = {resetFilter}
            dbViews = {dbViews}
            view = {view}
            setView = {setView}
            setDefaultView = {setDefaultView}
            search = {search}
            setSearch = {setSearch}
            query = {query}
            filterList = {assetFilters}
        />
    );

export default AssetsFilters;